import { useRouteMatch } from 'react-router-dom';

export function useParentRoute() {
    const routeMatch = useRouteMatch();

    return routeMatch.path.substr(0, routeMatch.url.lastIndexOf('/'));
}

